import * as THREE from 'three';
import { PLAYER_SPEED, JUMP_VELOCITY, FLY_SPEED, SWIM_SPEED, SPRINT_SPEED_MULTIPLIER } from '../constants.js';

const DOUBLE_TAP_TIME = 300;

export class PlayerController {
  constructor(player, fpsCamera, inputManager) {
    this.player = player;
    this.camera = fpsCamera;
    this.input = inputManager;
    this._lastSpaceTime = 0;
    this._spaceWasDown = false;
    this.sprinting = false;
    this.health = null; // set by main.js
  }

  update(dt) {
    this.camera.update(this.input.mouseDX, this.input.mouseDY);

    const spaceDown = this.input.isKeyDown('Space');

    // Double-tap Space to toggle flying
    if (spaceDown && !this._spaceWasDown) {
      const now = performance.now();
      if (now - this._lastSpaceTime < DOUBLE_TAP_TIME) {
        this.player.toggleFlying();
        this._lastSpaceTime = 0;
      } else {
        this._lastSpaceTime = now;
      }
    }
    this._spaceWasDown = spaceDown;

    // Movement direction
    const forward = this.camera.getForward();
    const right = this.camera.getRight();
    const moveDir = new THREE.Vector3(0, 0, 0);

    let speed;
    if (this.player.flying) {
      speed = FLY_SPEED;
    } else if (this.player.inWater) {
      speed = SWIM_SPEED;
    } else {
      speed = PLAYER_SPEED;
    }

    if (this.input.isKeyDown('KeyW')) moveDir.add(forward);
    if (this.input.isKeyDown('KeyS')) moveDir.sub(forward);
    if (this.input.isKeyDown('KeyD')) moveDir.add(right);
    if (this.input.isKeyDown('KeyA')) moveDir.sub(right);

    const isMoving = moveDir.lengthSq() > 0;
    const ctrlDown = this.input.isKeyDown('ControlLeft') || this.input.isKeyDown('ControlRight');
    const canSprint = this.health ? this.health.canSprint : true;

    // Sprint: Ctrl + moving + on ground + enough hunger
    this.sprinting = ctrlDown && isMoving && this.player.onGround && !this.player.flying && !this.player.inWater && canSprint;
    this.player.sprinting = this.sprinting;

    if (this.health) {
      this.health.sprinting = this.sprinting;
      if (this.sprinting) this.health.onSprint(dt);
    }

    if (this.sprinting) {
      speed *= SPRINT_SPEED_MULTIPLIER;
    }

    if (isMoving) {
      moveDir.normalize();
      this.player.velocity.x = moveDir.x * speed;
      this.player.velocity.z = moveDir.z * speed;
    } else {
      this.player.velocity.x = 0;
      this.player.velocity.z = 0;
    }

    if (this.player.flying) {
      if (this.input.isKeyDown('Space')) {
        this.player.velocity.y = FLY_SPEED;
      } else if (this.input.isKeyDown('ShiftLeft') || this.input.isKeyDown('ShiftRight')) {
        this.player.velocity.y = -FLY_SPEED;
      } else {
        this.player.velocity.y = 0;
      }
    } else if (this.player.inWater) {
      // Swimming: Space to go up, Shift to sink
      if (spaceDown) {
        this.player.velocity.y = SWIM_SPEED;
      } else if (this.input.isKeyDown('ShiftLeft') || this.input.isKeyDown('ShiftRight')) {
        this.player.velocity.y = -SWIM_SPEED;
      }
    } else {
      if (spaceDown && this.player.onGround) {
        this.player.velocity.y = JUMP_VELOCITY;
      }
    }
  }

  isWalking() {
    return (this.input.isKeyDown('KeyW') || this.input.isKeyDown('KeyS') ||
            this.input.isKeyDown('KeyA') || this.input.isKeyDown('KeyD'));
  }
}
